import { render, staticRenderFns } from "./ServicesToPerformedComponent.vue?vue&type=template&id=3115bc5b&scoped=true&"
import script from "./ServicesToPerformedComponent.vue?vue&type=script&lang=js&"
export * from "./ServicesToPerformedComponent.vue?vue&type=script&lang=js&"
import style0 from "./ServicesToPerformedComponent.vue?vue&type=style&index=0&id=3115bc5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115bc5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
